import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './ui/layout/App';
import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);